import React from 'react'
import Navbar from '../inc/Navbar'

import { Link } from "react-router-dom";

import "./Room.css";
import ScrollToTop from "react-scroll-to-top";


import Vanyaroom from "../images/Vanya 104.jpg";
import vinodniroom from "../images/Vinodini_room.jpg";



function SuperDeluxe() {


  return (
    <div>
      <Navbar />
      <br />
      <br />

      <br />
      <br />
      {/* <img src="" width="100%" alt="krishnanagar-hotel" /> */}
      <br />
      <div style={{ color: "Green", display: 'flex', justifyContent: 'flex-start', margin: "2px" }} className="fixed-bottom shadow mb-1">
        <a className='vevaroomberhampore shadow' href='tel: 9046258702'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" style={{ color: "white" }} fill="currentColor" class="bi bi-telephone" viewBox="0 0 16 16">
          <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
        </svg> Super Deluxe Room Reservation <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
            <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
          </svg></a>
      </div>
      <ScrollToTop smooth top="100" color="darkgoldenrod" />
      <div className='familyroom'>
        <div className="album py-2">
          <div className="container mt-2">
            <h3 className='mb-0' style={{ color: "white" }}>Super Deluxe Room</h3>
            <hr className='mb-1' style={{ color: "white" }} />
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" style={{ color: "white" }} >Home</Link></li>
                <li style={{ color: "white" }} className="breadcrumb-item active" aria-current="page">ROOM NO. - 203, 204, 303, 304</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <br />
      <center>
        <div className='fonts'>
          <div className='album py-0'>
            <div className='container'>
              <div className='veva'>
                <h1><b>RESERVATION FOR Super Deluxe Room</b></h1>
              </div>
            </div>
          </div>
        </div>
      </center>

      <div className='album py-3'>
        <div className='container'>

          <div className="card mb-3" >
            <div className="row g-0">
              <div className="col-md-4">
                <img src={vinodniroom} className="img-fluid rounded-start" alt="Super deluxe Room" />
              </div>
              <div className="col-md-8">
                <div className="card-body">
                  <div className='veva101'>
                    <h4 className="card-titl mb-1"><b>ROOM NO. - 203, 204, 303, 304 <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                      <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05" />
                    </svg></b></h4>
                  </div>
                  <p className="card-text mb-1">Description - Ac Room,  Best Luxury Clean AC Room in Berhampore at Chaltia </p>
                  <a href='https://g.co/kgs/bGYUqH7' target="_blank" rel="noopener noreferrer">
                    <button className='direction mb-2'><small>View Direction <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-sign-merge-left" viewBox="0 0 16 16">
                      <path d="M7.25 6v1q-.211.451-.588.95c-.537.716-1.259 1.44-2.016 2.196l.708.708.015-.016c.652-.652 1.33-1.33 1.881-2.015V12h1.5V6h1.216a.25.25 0 0 0 .192-.41L8.192 3.23a.25.25 0 0 0-.384 0L5.842 5.59a.25.25 0 0 0 .192.41z" />
                      <path d="M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098zm-1.4.7a.495.495 0 0 1 .7 0l6.516 6.515a.495.495 0 0 1 0 .7L8.35 14.866a.495.495 0 0 1-.7 0L1.134 8.35a.495.495 0 0 1 0-.7L7.65 1.134Z" />
                    </svg></small></button>
                  </a>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <p className="card-text mb-2"><small className="text-muted"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-all" viewBox="0 0 16 16">
                      <path d="M12.354 4.354a.5.5 0 0 0-.708-.708L5 10.293 1.854 7.146a.5.5 0 1 0-.708.708l3.5 3.5a.5.5 0 0 0 .708 0zm-4.208 7-.896-.897.707-.707.543.543 6.646-6.647a.5.5 0 0 1 .708.708l-7 7a.5.5 0 0 1-.708 0" />
                      <path d="m5.354 7.146.896.897-.707.707-.897-.896a.5.5 0 1 1 .708-.708" />
                    </svg> Check in - 12:00 PM </small></p>
                    <p className="card-text mb-2"><small className="text-muted"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-all" viewBox="0 0 16 16">
                      <path d="M12.354 4.354a.5.5 0 0 0-.708-.708L5 10.293 1.854 7.146a.5.5 0 1 0-.708.708l3.5 3.5a.5.5 0 0 0 .708 0zm-4.208 7-.896-.897.707-.707.543.543 6.646-6.647a.5.5 0 0 1 .708.708l-7 7a.5.5 0 0 1-.708 0" />
                      <path d="m5.354 7.146.896.897-.707.707-.897-.896a.5.5 0 1 1 .708-.708" />
                    </svg> Check out - 10:00 AM </small></p>
                  </div>
                  <h5 className='mb-2'>Singale Occupancy: - <b>3000</b> | Double Occupancy: - <b>3200/-</b> + 5% GST</h5>


                  {/* <button type="button" className="button10 button11 me-2" data-bs-toggle="modal" data-bs-target="#exampleModal">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-check2-square" viewBox="0 0 16 16">
                      <path d="M3 14.5A1.5 1.5 0 0 1 1.5 13V3A1.5 1.5 0 0 1 3 1.5h8a.5.5 0 0 1 0 1H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8a.5.5 0 0 1 1 0v5a1.5 1.5 0 0 1-1.5 1.5z" />
                      <path d="m8.354 10.354 7-7a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0" />
                    </svg> VIEW PHOTOS (6)
                  </button> */}
                  <a href="superdeluxroom">
                    <buttn className="button10 button11 me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-images" viewBox="0 0 16 16">
                      <path d="M4.502 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" />
                      <path d="M14.002 13a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2V5A2 2 0 0 1 2 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-1.998 2M14 2H4a1 1 0 0 0-1 1h9.002a2 2 0 0 1 2 2v7A1 1 0 0 0 15 11V3a1 1 0 0 0-1-1M2.002 4a1 1 0 0 0-1 1v8l2.646-2.354a.5.5 0 0 1 .63-.062l2.66 1.773 3.71-3.71a.5.5 0 0 1 .577-.094l1.777 1.947V5a1 1 0 0 0-1-1z" />
                    </svg> VIEW PHOTO (6)</buttn>
                  </a>

                  <a href='tel: 9046258703'>
                    <button className="button10 button11 mt-1">Call Now</button>
                  </a>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>










      {/* <Facility/> */}
      <br />
    </div>
  )
}

export default SuperDeluxe